import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  modal: {
    '& .MuiDialog-paper': {
      minWidth: '600px',
      maxWidth: '800px',
      width: '90%',
    },
  },

  form: {
    padding: spacing(20),
    minHeight: '400px',
  },

  attachmentLabel: {
    fontFamily: Theme.Typography.FontFamily.Roboto,
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontSize: Theme.Typography.FontSize.Small,
    color: Theme.Colors.Grayscale.Eighty,
    marginBottom: spacing(8),
    display: 'block',
  },

  deleteButtonContainer: {
    position: 'absolute',
    bottom: spacing(18),
    right: spacing(285),
  },

  deleteButton: {
    color: Theme.Colors.Red.Base,
    borderColor: Theme.Colors.Red.Base,

    '&:hover': {
      backgroundColor: Theme.Colors.Red.Base,
      color: Theme.Colors.Grayscale.Four,
    },

    '&:disabled': {
      color: Theme.Colors.Grayscale.ThirtyTwo,
      borderColor: Theme.Colors.Grayscale.ThirtyTwo,
    },
  },

  // Estilos específicos para o campo "Tipo de registro"
  tipoRegistroGroup: {
    flexDirection: 'row !important',
    gap: `${spacing(16)}px !important`,
  },

  tipoRegistroRadio: {
    border: 'none !important',
    padding: '0 !important',
    width: 'auto !important',
    borderRadius: '0 !important',
    backgroundColor: 'transparent !important',

    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },

  // Estilos específicos para o campo "Tipo de reserva"
  tipoReservaGroup: {
    flexDirection: 'row !important',
    gap: `${spacing(16)}px !important`,
  },

  tipoReservaRadio: {
    border: 'none !important',
    padding: '0 !important',
    width: 'auto !important',
    borderRadius: '0 !important',
    backgroundColor: 'transparent !important',

    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
}))
